import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ProjectContext, UserContext } from '@core/context';
import { useProjectStore } from '@core/store';

import { normalizeProjectStoreNavLabels } from './normalizeProjectStoreNavLabels';

const useFeatureOptions = () => {
  const { project } = useContext(ProjectContext);
  const { flags } = project;
  const { user } = useContext(UserContext) || {};
  const moduleNames = useProjectStore(s => normalizeProjectStoreNavLabels(s.data.appearance.navigation.links));
  const { t } = useTranslation();

  // TODO-HUB1-MIGRATION: remove this once projects are all upgraded
  // This was renamed from blog to changelog in hub2
  if (moduleNames.blog) {
    moduleNames.blog = '';
  }

  // The joys of switching names halfway through the project
  // (See below in the `return` statement for more details!)
  if (moduleNames.recipes) {
    moduleNames.tutorials = moduleNames.recipes;
  }

  return {
    home: t('sections.home'), // for the header
    landing: t('sections.home'), // for the subnav
    docs: t('sections.guides'),

    // Why both?
    // See the comments in models/projects/index.js under `nav_names` to
    // understand what we have to do to deprecate both of these!
    //
    // Also: https://github.com/readmeio/readme/pull/8965#discussion_r1170694747
    tutorials: t('sections.recipes'), // for the subnav
    recipes: t('sections.recipes'), // for the header

    reference: t('sections.reference'),
    ...(flags?.graphql === true && { graphql: t('sections.graphql') }),
    logs: t('sections.apiLogs'),
    changelog: t('sections.changelog'),
    discuss: t('sections.discussions'),
    user: (user && user.name) || false,
    ...Object.keys(moduleNames).reduce((all, key) => {
      const val = moduleNames[key] || false;
      if (val) all[key] = val;
      return all;
    }, {}),
  };
};

export default useFeatureOptions;
